/* permet de tronquer une paragraphe sans couper au beau milieu d'un mot - par défaut 100 caractères si non précisé  */
export function tronquer(phrase, nbrCaracteres = 100) {
  if (phrase) {
    let tailleDecoupageEnCours = 0;
    let phraseDecoupeeEnMot = phrase.split(" ");
    let phraseTronquee = "";
    for (var i = 0; i < phraseDecoupeeEnMot.length; i++) {
      tailleDecoupageEnCours = tailleDecoupageEnCours + phraseDecoupeeEnMot[i].length;
      phraseTronquee += phraseDecoupeeEnMot[i] + " ";

      if (tailleDecoupageEnCours > nbrCaracteres) {
        phraseTronquee += " ";
        tailleDecoupageEnCours = 0;
        return phraseTronquee + " ...";
      }
    }
    return phrase;
  }
  return "";
}
